<template lang="pug">
	.v-managment-timing.management-timing(v-if="data")
		h1.management-timing__title(v-if="data.title") {{ data.title }}

		template(v-if="!isSm")
			.management__group(v-for="(group, groupIndex) in data.items" :key="groupIndex")
				table.management__table()
					thead
						tr
							th {{ group.dictionary.date }}
							th {{ group.dictionary.time }}
							th {{ group.dictionary.phoneNumber }}
							th {{ group.dictionary.position }}
					tbody
						tr(v-for="person in group.list" :key="person.id")
							td(valign="top") {{ person.date }}
							td(valign="top")  {{ person.time }}
							td(valign="top" v-html="person.phoneNumber")
							td(valign="top" v-html="person.position")
		template(v-else)
			.management__group(v-for="(group, groupIndex) in data.items" :key="groupIndex")
				.management-timing__block(v-for="(item, i) in group.list" :key="i")
					.management-timing__block-header
						span.management-timing__block-header_position {{item.position}}
						span.management-timing__block-header_name {{ item.phoneNumber }}
					.management-timing__block-body
						table.management__table
							thead
								tr
									th {{ group.dictionary.date }}
									th {{ group.dictionary.time }}
							tbody
								tr
									td(valign="top" v-html="item.date")
									td(valign="top" v-html="item.time")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>